import PropTypes from 'prop-types';
import React from 'react';
import { formatAsMoney } from '../../shared/util/transform';
import ButtonComponent from '../component/global/Button';
import ButtonGroupComponent from '../component/global/ButtonGroup';
import ItemList from '../component/global/ItemList';
import ItemListHeaderComponent from '../component/global/ItemListHeader';
import ItemListMenuComponent from '../component/global/ItemListMenu';
import LabelComponent from '../component/global/Label';
import LabelsComponent from '../component/global/Labels';
import PageHeaderComponent from '../component/global/PageHeader';
import PeopleComponent from '../component/global/People';
import TitleComponent from '../component/global/Title';
import TotalComponent from '../component/global/Total';
import StageComponent from '../component/salestrekker/Stage';

const Tickets = ({ icon, pageTitle, scope, data, prop, updated }) => {
  const header = (
    orderBy,
    isDescending,
    getOrderAndDirection,
    getIsOrdered,
    toggleBulkActions,
    countOfSelectedItems,
    shown,
    disableOrderAndDirection
  ) => (
    <ItemListHeaderComponent
      eventId="ticketsListHeaderSort"
      toggleBulkActions={toggleBulkActions}
      getOrderAndDirection={getOrderAndDirection}
      getIsOrdered={getIsOrdered}
      isDescending={isDescending}
      disableOrderAndDirection={disableOrderAndDirection}
      columns={[
        { id: 'name', coerce: 'string', title: 'Name', isDefault: true },
        { id: 'values.onceOff', coerce: 'number', title: 'Value' },
        { id: 'values.onceOffDueDate', coerce: 'number', title: 'Settlement due' },
        { id: 'values.financeDueDate', coerce: 'number', title: 'Finance due' },
        { id: 'idStage', coerce: 'string', title: 'Stage' },
        { id: 'status', coerce: 'number', title: 'Status' },
        { id: 'idLabels', coerce: 'string', title: 'Labels' },
        { id: 'idOwner', coerce: 'string', title: 'Owner' }
      ]}>
      <ItemListMenuComponent>
        <TotalComponent
          prefix="Selected"
          shown={countOfSelectedItems}
          size={shown}
          type="Deals"
        />
        <ButtonComponent
          id="ticketsListHeaderLabel"
          icon="icon-tags-edit"
          toolTip="Add label(s)"
        />
        <ButtonComponent
          id="ticketsListHeaderStatus"
          icon="icon-task-list-check"
          toolTip="Set status"
        />
      </ItemListMenuComponent>
    </ItemListHeaderComponent>
  );

  const body = (dataState, item, isSelected) => (
    <dl data-item-selected={isSelected}>
      <dt>
        <TitleComponent title={item.getName()} />
      </dt>
      <dd>{formatAsMoney(item.values.onceOff, scope?.Root?.CurrentCurrency()?.symbol, 0)}</dd>
      <dd>{item.getDueDate(scope?.Root?.CurrentTimeZone(), scope?.Root?.CurrentLocale())}</dd>
      <dd>
        {item.getFinanceDueDate(scope?.Root?.CurrentTimeZone(), scope?.Root?.CurrentLocale())}
      </dd>
      <dd>
        <StageComponent
          workflows={dataState?.Workflows?.getCollectionData()}
          idWorkflow={item.idWorkflow}
          idStage={item.idStage}
        />
      </dd>
      <dd>
        <LabelComponent name={item.getStatus()} />
      </dd>
      <dd>
        <LabelsComponent labels={dataState?.Labels?.getCollectionData()} ids={item.idLabels} />
      </dd>
      <dd>
        <PeopleComponent people={dataState?.Accounts?.getCollectionData()} ids={item.idOwner} />
      </dd>
      <ItemListMenuComponent>
        <ButtonComponent
          id="ticketsListEdit"
          icon="icon-pencil-2"
          toolTip={`Edit ${item.getName()}`}
          toolTipPosition="left"
          clickButtonArgs={item}
        />
        <ButtonComponent
          id="ticketsListLabel"
          icon="icon-tags-edit"
          toolTip={`Edit label(s) for ${item.getName()}`}
          toolTipPosition="left"
          clickButtonArgs={item}
        />
      </ItemListMenuComponent>
    </dl>
  );

  return (
    <>
      <PageHeaderComponent icon={icon} title={pageTitle}>
        <ButtonGroupComponent>
          <ButtonComponent id="ticketsBoard" title="Board" icon="icon-layout-column" />
          <ButtonComponent id="ticketsFiltersToggle" title="Filter" icon="icon-filter-1" />
          <ButtonComponent id="ticketAddNew" title="Add new" icon="icon-add-square" />
        </ButtonGroupComponent>
      </PageHeaderComponent>
      <ItemList
        data={data}
        prop={prop}
        type="Deals"
        header={header}
        body={body}
        updated={updated}
      />
    </>
  );
};

Tickets.propTypes = {
  icon: PropTypes.string.isRequired,
  pageTitle: PropTypes.string.isRequired,
  scope: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  prop: PropTypes.string.isRequired,
  updated: PropTypes.string
};

Tickets.defaultProps = {
  updated: undefined
};

export default Tickets;
